module.exports = __webpack_public_path__ + "assets/list-unordered.9dd656cc.svg";